export default __webpack_public_path__ + "static/media/boton_safekey.0ded9813.png";